import React, { Fragment,useCallback } from "react";
import { Row, Col, Container } from "reactstrap";
import CountUp from "react-countup";
import { getCurrencySymbol, tostring } from "../../../Common/Appcommon";
import { useAppContext } from "../../../Context/AppContext";

export const AgentDashboardSummaryBox = (props) => {
    const { subCurrencyISO } = useAppContext();
    //let currency = subCurrencyISO?? 'usd';
    const summary = props.summary;
    //const prefixvalue = getCurrencySymbol(currency);
    return (
        <Fragment>
            <Container>
                <div className="summary-container">
                    <Row>
                        {summary &&
                            summary.map((val, index) => {
                                let header = val.header;
                                let body = val.body;
                                let footerheader = val.footerheader;
                                let footerbody = val.footerbody;
                                let prefix = val.prefix;
                                let isFloat = body % 1 !== 0;
                                return (
                                    <Col md="6" lg="3" key={index}>
                                        <div className="card mb-3 widget-chart text-start">
                                            <div className="widget-chart-content">
                                                <div className="widget-subheading">{header}</div>
                                                <div className="widget-numbers">
                                                    <CountUp
                                                        start={0}
                                                        end={body}
                                                        separator=","
                                                        decimals={isFloat ? 2 : 0}
                                                        decimal="."
                                                        prefix={prefix}
                                                        useEasing={false}
                                                        duration={3}
                                                        className="vi-success-text"
                                                    />
                                                </div>
                                                <div className="widget-description">
                                                    <span className="ps-1">
                                                        <span className="theme-c-g">
                                                            {footerbody}
                                                        </span>
                                                        <span className="dashboard-footerheader">
                                                            {footerheader}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                );
                            })}
                    </Row>
                </div>
            </Container>
        </Fragment>
    );
};